import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { UploaderComponent } from '@shared/modules/uploader/containers/uploader/uploader.component';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  imports: [UploaderComponent, ManageValidatorDisplayDirective],
})
export class FileInputComponent extends FieldType {}
